const prefix = "calendar."

export const CALENDAR_MODAL_CONST = {
    tNamespace: "common",
    tPaths: {
        errorRangePick: `${prefix}error-range-pick`,
        errorRangeInvalid: `${prefix}error-range-invalid`,
        today: `${prefix}today`,
        date: `${prefix}date`,
        time: `${prefix}time`
    },
    dateFormat: "dd.MM.yyyy",
    getDatesBetween: (start: Date, end: Date) => {
        const dates: Date[] = []
        const theDate = new Date(start)

        while (theDate < end) {
            dates.push(new Date(theDate))
            theDate.setDate(theDate.getDate() + 1)
        }
        dates.push(end)

        return dates
    },
    handleChangeTime:
        (baseDate: Date | null, setDate: (date: Date) => void, validateCallback: (date: Date) => void) =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (!baseDate) return
            const [hours = 0, minutes = 0, seconds = 0] = e.target.value.split(":").map(Number)
            const newDate = new Date(baseDate)
            newDate.setHours(hours, minutes, seconds, 0)
            setDate(newDate)
            validateCallback(newDate)
        }
}
